import React from "react";
import { useAuth } from "../context/AuthContext";

const Header = ({ onTabChange, activeTab }) => {
    //Get auth state and actions from context
    const { authToken, handleLogout } = useAuth();
    const isLoggedOut = !authToken;
    const isLoginPage = activeTab === 'login';
    const isRegisterPage = activeTab === 'register';


    // The header is fixed to the top and spans the entire width.
    return (

        <header className="fixed top-0 left-0 right-0 z-40 bg-card-white shadow-md">
            <div className="max-w-full mx-auto px-8 py-4 flex justify-between items-center">
                {/* Logo/Title - Button action navigates to dashboard */}
                <div className="flex items-center"> {/* Added a div to group logo and title */}
                    <img
                        src="/logo.png"
                        alt="FitTrack Pro Logo"
                        className="h-10 w-10 mr-2" // Adjusted height, width, and margin for standard size
                    />
                    <button
                        onClick={() => onTabChange("dashboard")}
                        className="text-4xl font-bold text-primary-blue flex items-center hover:opacity-90 transition-opacity" // Adjusted text size
                    >
                        FitTrack
                    </button>
                </div>

                {/* Navigation/Actions */}
                <div className="flex space-x-4">
                    {/* Only show Login and Register buttons if logged out */}
                    {isLoggedOut && (
                        <>
                            <button
                                className={`text-lg font-semibold transition-colors ${isLoginPage ? 'text-primary-hover' : 'text-text-muted hover:text-primary-blue'}`}
                                onClick={() => onTabChange('login')}
                            >
                                Login
                            </button>
                            <button
                                className={`text-lg font-semibold px-5 py-2 rounded-full shadow-md transition-all ${isRegisterPage ? 'bg-accent-green text-white hover:bg-green-600' : 'bg-primary-blue text-white hover:bg-primary-hover'}`}
                                onClick={() => onTabChange('register')}
                            >
                                Register
                            </button>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;